
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import { Situacion } from '@/__env/lib/Pantalla/Situacion';
    import { Empresa } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';
    import moment from 'moment';

    import { WaitEntre } from '@/__env/ext';
import { EstadisticaVentas, Viajante } from '@/__env/lib/Ventas/Viajantes';
    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }

        public Estado: 'ok' | 'cargando' = 'cargando';

        @Prop( { type: Viajante } )
        public Viajante: Viajante;
        @Watch( 'Viajante', { immediate: true } )
        onEmpresa()
        {
            this.buscar();
        }

        public Item: EstadisticaVentas = new EstadisticaVentas();
        async buscar()
        {
            await WaitEntre( 1000, 2000 );
            this.Item = await EstadisticaVentas.actual( this.Viajante );
            this.Estado = 'ok';
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {

            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {

        }

        public Seleccionar( x: Viajante )
        {
            this.Controlador.ViajanteSeleccionado = x;
            this.Controlador.Vista.Modo = 'viajante';
        }
    }
